import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AuthProvider from "./hooks/AuthProvider";
import ApiStoreProvider from './hooks/ApiStoreContext';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgetPassword from './pages/ForgetPassword';
import Dashboard from './pages/Dashboard';
import PrivateRoute from './components/PrivateRoute';
import Layout from './pages/layout/Layout';
import Category from './pages/category/Category';
import AddCategory from './pages/category/AddCategory';
import AddProduct from './pages/product/AddProduct';
import Product from './pages/product/Product';
import Order from './pages/order/Order';
import User from './pages/user/User';
import AddUser from './pages/user/AddUser';
import Coupon from './pages/coupon/Coupon';
import AddCoupon from './pages/coupon/AddCoupon';
import Feedback from './pages/feedback/Feedback';
import AddFeedback from './pages/feedback/AddFeedback';
import Banner from './pages/banner/Banner';
import AddBanner from './pages/banner/AddBanner';
import ChangePassword from './pages/ChangePassword';
import GetInTouch from './pages/contact/GetInTouch';
import ViewOrder from './pages/order/ViewOrder';

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <ApiStoreProvider>
          <Routes>
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forget-password" element={<ForgetPassword />} />
            <Route element={<PrivateRoute />}>
              <Route element={<Layout />} >
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/category" element={<Category />} />
                <Route path="/add-category" element={<AddCategory />} >
                  <Route path='/add-category/:categoryId' />
                </Route>
                <Route path="/product" element={<Product />} />
                <Route path="/add-product" element={<AddProduct />} >
                  <Route path='/add-product/:productId' />
                </Route>
                <Route path="/order" element={<Order />} />
                <Route path="/view-order" element={<ViewOrder />} >
                  <Route path='/view-order/:orderId' />
                </Route>
                <Route path="/user" element={<User />} />
                <Route path="/add-user" element={<AddUser />} >
                  <Route path='/add-user/:userId' />
                </Route>
                <Route path="/coupon" element={<Coupon />} />
                <Route path="/add-coupon" element={<AddCoupon />} >
                  <Route path='/add-coupon/:couponId' />
                </Route>
                <Route path="/feedback" element={<Feedback />} />
                <Route path="/add-feedback" element={<AddFeedback />} >
                  <Route path='/add-feedback/:feedbackId' />
                </Route>
                <Route path="/get-in-touch" element={<GetInTouch />} />
                <Route path="/banner" element={<Banner />} />
                <Route path="/add-banner" element={<AddBanner />} >
                  <Route path='/add-banner/:bannerId' />
                </Route>
              </Route>
            </Route>
          </Routes>
        </ApiStoreProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;